(function ($) {
    function productSlider() {
        $(".product-slider").each(function () {
            var $this = $(this);
            var Products = new Swiper($this.find('.swiper-container')[0], {
                slidesPerView: 'auto',
                loop: false,
                spaceBetween: 10,
                freeMode: true,
                mousewheel: {
                    forceToAxis: true,
                },
                // navigation: {
                //     nextEl: $this.find('.swiper-button-next')[0],
                //     prevEl: $this.find('.swiper-button-prev')[0],
                // },
                // scrollbar: {
                //     el: $this.find('.swiper-scrollbar')[0],
                //     hide: false,
                //     draggable: true,
                // },
                breakpoints: {
                    767: {
                        freeMode: false,
                        slidesPerView: 4,
                    },
                }
            });
        });
    }

    productSlider();

    $(document).gp_ready(function () {
        productSlider();
    });
})(jQuery);
